// YEKÜV mock data — all content extracted from real site + crafted

export const SITE = {
  name: 'YEKÜV',
  fullName: '21. Yüzyıl Eğitim ve Kültür Vakfı',
  since: 1992,
  tagline: '"Bir Çocuk Daha Okusun Diye..."',
  phone: '444 28 39',
  email: 'yekuv@yekuv.org',
  address: 'Ortaklar Cad. Bahçeler Sokak No:2 Daire: 9 Mecidiyeköy / İSTANBUL',
  socials: {
    facebook: '#',
    twitter: '#',
    instagram: '#',
    youtube: '#',
  },
};

export const NAV = [
  {
    label: 'Kurumsal',
    path: '/kurumsal',
    submenu: [
      { label: 'Yeküv Tarihçesi', path: '/kurumsal#tarihce' },
      { label: 'Başkanlarımız', path: '/kurumsal/baskanlar' },
      { label: 'Yönetim Kurulumuz', path: '/kurumsal#yonetim' },
      { label: 'Kurullarımız', path: '/kurumsal/kurullar' },
      { label: 'Vizyon & Misyon', path: '/kurumsal#vizyon' },
      { label: 'Medyada YEKÜV', path: '/kurumsal/medya' },
      { label: 'Yayınlarımız', path: '/kurumsal/yayinlar' },
      { label: 'YEKÜV Nilüfer Gökay Ortaokulu', path: '/kurumsal/okul' },
      { label: 'Eğitim Destek Birimlerimiz', path: '/kurumsal/birimler' },
      { label: 'Destekçilerimiz', path: '/kurumsal/destekciler' },
      { label: 'Kamu Yararına Vergi Muafiyeti', path: '/kurumsal/vergi' },
      { label: 'KVKK Yönetmeliği', path: '/kurumsal/kvkk' },
    ],
  },
  {
    label: 'Bağışlar',
    path: '/bagis/turler',
    submenu: [
      { label: 'Bağış Türlerimiz', path: '/bagis/turler' },
      { label: 'Bağış Kanallarımız', path: '/bagis/kanallar' },
      { label: 'Özel Gün Bağışı', path: '/bagis/ozel-gun' },
      { label: 'Online Bağış', path: '/bagis' },
    ],
  },
  {
    label: 'Burslar',
    path: '/burslar',
    submenu: [
      { label: 'Üniversite Başvuru', path: '/burslar?tab=universite' },
      { label: 'İlk · Orta · Lise Başvuru', path: '/burslar?tab=ilk-orta-lise' },
      { label: 'Kayıt Yenileme', path: '/burslar?tab=yenileme' },
      { label: 'Gerekli Evraklar', path: '/burslar#evrak' },
    ],
  },
  {
    label: 'Projeler & Etkinlikler',
    path: '/projeler',
    submenu: [
      { label: 'Devam Eden Projeler', path: '/projeler?tab=devam' },
      { label: 'Tamamlanan Projeler', path: '/projeler?tab=tamamlanan' },
      { label: 'Sosyal & Kültürel Etkinlikler', path: '/projeler?tab=etkinlik' },
    ],
  },
  {
    label: 'Duyurular',
    path: '/duyurular',
  },
  {
    label: 'İletişim',
    path: '/iletisim',
  },
];

export const DONATION_TYPES = [
  {
    id: 'genel',
    slug: 'genel',
    title: 'Genel Bağış',
    kicker: 'Serbest Kullanım',
    description: 'Vakfımızın eğitim ve kültür faaliyetlerinin tümünde kullanılabilecek, en esnek destek biçimi.',
    image: 'https://images.pexels.com/photos/6646918/pexels-photo-6646918.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940',
    amounts: [100, 250, 500, 1000],
    cta: 'Bağış Yap',
    link: '/bagis',
  },
  {
    id: 'ozelgun',
    slug: 'ozel-gun',
    title: 'Özel Gün Bağışı',
    kicker: 'Anılmaya Değer',
    description: 'Doğum günü, evlilik yıl dönümü, anma ve özel günleriniz için sevdiklerinize anlamlı bir hediye.',
    image: 'https://images.pexels.com/photos/1729797/pexels-photo-1729797.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940',
    amounts: [200, 500, 750, 1000, 1250, 2000],
    cta: 'Detaylı Bağış',
    link: '/bagis/ozel-gun',
  },
  {
    id: 'proje',
    slug: 'proje',
    title: 'Proje Bağışı',
    kicker: 'Belirli Amaç',
    description: 'Seçtiğiniz projeye doğrudan destek olun; kütüphane, atölye, yaz okulu gibi belirli programlara fon ayırın.',
    image: 'https://images.pexels.com/photos/6646865/pexels-photo-6646865.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940',
    amounts: [500, 1000, 2500, 5000],
    cta: 'Proje Seç',
    link: '/bagis?type=proje',
  },
  {
    id: 'devre',
    slug: 'devre',
    title: 'Devre Bursu',
    kicker: 'Uzun Vadeli',
    description: 'Bir öğrencinin eğitim süresi boyunca tüm bursunu üstlenerek dönüştürücü bir etki yaratın.',
    image: 'https://images.pexels.com/photos/4778611/pexels-photo-4778611.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940',
    amounts: [400, 750, 1250],
    cta: 'Bilgi Al',
    link: '/iletisim',
  },
  {
    id: 'egitim',
    slug: 'egitim',
    title: 'Aylık Eğitim Bursu',
    kicker: 'Düzenli Destek',
    description: 'Her ay düzenli olarak bir öğrencinin aylık bursuna katkı sağlayın.',
    image: 'https://images.pexels.com/photos/207691/pexels-photo-207691.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940',
    amounts: [250, 500, 1000],
    cta: 'Aylık Destek',
    link: '/bagis?recurring=true',
  },
];

export const SPECIAL_DAYS = [
  { id: 'dogum', title: 'Doğum Günü', emoji: '🎂', tone: 'Kutlama', text: 'Doğum günü hediyesi yerine bir çocuğun eğitimine destek.' },
  { id: 'gecmis', title: 'Geçmiş Olsun', emoji: '🌿', tone: 'Dilek', text: 'Sevdiklerinizin iyileşmesi dileğiyle anlamlı bir destek.' },
  { id: 'aci', title: 'Acınızı Paylaşıyoruz', emoji: '🕊️', tone: 'Anma', text: 'Kaybettiğimiz sevdiklerimizin anısını eğitimle yaşatalım.' },
  { id: 'bebek', title: 'Hoşgeldin Bebek', emoji: '👶', tone: 'Doğum', text: 'Yeni doğan bebekler için umut dolu bir karşılama.' },
  { id: 'evlilik', title: 'Evlilik Yıl Dönümü', emoji: '💍', tone: 'Birliktelik', text: 'Beraber geçen yılları paylaşmanın güzel bir yolu.' },
  { id: 'sevgili', title: 'Sevgililer Günü', emoji: '💕', tone: 'Sevgi', text: 'Sevginizi paylaşmanın en anlamlı yolu.' },
  { id: 'yeni-is', title: 'Yeni İş', emoji: '✨', tone: 'Başarı', text: 'Yeni kariyer başlangıçları için eğitime dokunan bir kutlama.' },
  { id: 'avukat', title: 'Avukatlar Günü', emoji: '⚖️', tone: 'Meslek', text: 'Adalet için çalışanlara hayata dokunan bir hediye.' },
  { id: 'ogretmen', title: 'Öğretmenler Günü', emoji: '📚', tone: 'Meslek', text: 'Eğitime hayat verenlere eğitimle teşekkür.' },
  { id: 'yilbasi', title: 'Yılbaşı', emoji: '🌟', tone: 'Yeni Yıl', text: 'Yeni yılda umuda yer açalım.' },
  { id: 'tip', title: 'Tıp Bayramı', emoji: '🩺', tone: 'Meslek', text: 'Sağlığı önemseyenlere geleceğe yatırım teşekkürü.' },
  { id: 'baba', title: 'Babalar Günü', emoji: '👔', tone: 'Aile', text: 'Babalarımıza iz bırakan bir hediye.' },
  { id: 'anne', title: 'Anneler Günü', emoji: '🌸', tone: 'Aile', text: 'Annelerimize en kıymetli armağan: bir çocuğun geleceği.' },
  { id: 'umut', title: 'Umut Kızlar', emoji: '🎀', tone: 'Kampanya', text: 'Kız çocuklarının eğitimi için özel kampanya.' },
  { id: 'yekuv-sana', title: "Yekuv'den Sana", emoji: '💌', tone: 'Özel', text: 'YEKÜV ailesinden size özel bir jest.' },
  { id: 'hayirli', title: 'Hayırlı Olsun', emoji: '🤲', tone: 'Tebrik', text: 'Tebrik için eğitime dokunan bir hediye.' },
];

export const PAST_PRESIDENTS = [
  {
    id: 'gulbin-sozen',
    name: 'Av. F. Gülbin Sözen',
    term: '1992 – 2017',
    title: 'Kurucu & Onursal Başkan',
    image: '/presidents/gulbin-sozen.jpg',
    years: 25,
    bio: "Vakfımızın kurucu başkanı Av. F. Gülbin Sözen, 1992'den 2017'ye kadar 25 yıl boyunca YEKÜV'e başkanlık yapmış; vakfımızın kurumsal kimliğini, değerlerini ve misyonunu şekillendirmiştir. Eğitimde fırsat eşitliği ideali etrafında binlerce öğrenciye ulaşan sivil eğitim ağımızın mimarı olarak, bugün onursal başkanımız olarak aramızdadır.",
    highlights: ['Vakfın kuruluşu (1992)', 'İlk 1.000 bursiyer (2001)', 'Ulusal ölçek (2010)', 'Onursal Başkanlık'],
  },
  {
    id: 'isin-ozdemir',
    name: 'H. Işın Özdemir',
    term: '2017 – 2023',
    title: 'Yönetim Kurulu Başkanı',
    image: '/presidents/isin-ozdemir.jpg',
    years: 6,
    bio: "H. Işın Özdemir, 2017-2023 yılları arasında vakfımızın başkanlığını yürüttü. Görev döneminde vakfımızın dijital dönüşümünü başlatmış; online bağış altyapısı, kurumsal bağışçı ağı ve ulusal ölçekteki proje ortaklıklarımızı büyütmüştür.",
    highlights: ['Dijital dönüşüm', 'Kurumsal bağışçı ağı', 'Yeni proje ortaklıkları', 'Genç bursiyer programları'],
  },
  {
    id: 'tulay-erkan',
    name: 'Ş. Tülay Erkan',
    term: '2023 – Günümüz',
    title: 'Yönetim Kurulu Başkanı',
    image: '/presidents/tulay-erkan.jpg',
    years: null,
    bio: "Ş. Tülay Erkan, 2023'ten itibaren vakfımızın başkanı olarak görev yapmaktadır. Gençlik katılımını, dijital beceri atölyelerini ve yenilikçi programları ön plana çıkaran liderlik anlayışıyla, YEKÜV'ün yeni dönemini şekillendirmektedir.",
    highlights: ['Dijital beceri atölyeleri', 'Gençlik çalıştayları', 'Yapay zekâ programları', "Anadolu'ya Öğretmen Yolculukları"],
  },
];

export const AUDIT_BOARD = [
  { name: 'Dr. Hasan Kuran', role: 'Denetim Kurulu Başkanı' },
  { name: 'Nurten Akın', role: 'Denetim Kurulu Üyesi' },
  { name: 'Erdal Yıldız', role: 'Denetim Kurulu Üyesi' },
];

export const ADVISORY_BOARD = [
  { name: 'Prof. Dr. İlber Uslu', role: 'Üst Danışma Kurulu Başkanı' },
  { name: 'Selma Gürpınar', role: 'Üye — Sivil Toplum' },
  { name: 'Av. Zeki Özbay', role: 'Üye — Hukuk' },
  { name: 'Prof. Dr. Meltem Arı', role: 'Üye — Akademi' },
  { name: 'Nihat Koçak', role: 'Üye — Kurumsal İletişim' },
  { name: 'Dr. Şebnem Kara', role: 'Üye — Eğitim Politikaları' },
];

export const MEDIA_MENTIONS = [
  { id: 1, outlet: 'Hürriyet', date: '14 Mart 2026', title: "YEKÜV'ün 34. Yılında 12.500 Bursiyere Uzanan El", excerpt: 'Vakfın 34. kuruluş yılında açıklanan rakamlar, Türkiye\'nin sivil eğitim ağının gücünü gösteriyor.', link: '#' },
  { id: 2, outlet: 'TRT Haber', date: '22 Şubat 2026', title: 'Mezunlar Buluşmasında Duygusal Anlar', excerpt: 'Yıllar sonra bir araya gelen bursiyerler hikâyelerini paylaştı.', link: '#' },
  { id: 3, outlet: 'Cumhuriyet', date: '10 Ocak 2026', title: "Kitap Bağışı Kampanyası 21 İle Ulaştı", excerpt: 'Anadolu\'nun köy okullarına kütüphane kurma kampanyası hız kesmeden sürüyor.', link: '#' },
  { id: 4, outlet: 'NTV', date: '05 Aralık 2025', title: "Dijital Atölyeler Bursiyerlere Yeni Kapılar Açıyor", excerpt: 'Yapay zekâ çağında öğrencilere yönelik ücretsiz atölye programları...', link: '#' },
  { id: 5, outlet: 'Sabah', date: '18 Kasım 2025', title: "YEKÜV'den Öğretmenler Günü'ne Özel Bağış Kampanyası", excerpt: 'Bağışçılar öğretmenleri anmak için YEKÜV aracılığıyla eğitime destek oldu.', link: '#' },
  { id: 6, outlet: 'Anadolu Ajansı', date: '12 Ekim 2025', title: "840 Yeni Bursiyer YEKÜV Ailesinde", excerpt: 'Yeni eğitim yılında 840 öğrenci bursiyer oldu.', link: '#' },
];

export const PUBLICATIONS = [
  { id: 'p1', type: 'Kitap', title: 'YEKÜV 30 Yıl: Bir Vakıf Tarihi', year: 2022, pages: 348, cover: 'https://images.pexels.com/photos/1029141/pexels-photo-1029141.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=700&w=500', excerpt: 'Vakfımızın 30 yıllık deneyimini belgeleyen anma kitabı.' },
  { id: 'p2', type: 'Kitap', title: 'Eğitim için El Ele', year: 2019, pages: 212, cover: 'https://images.pexels.com/photos/1925536/pexels-photo-1925536.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=700&w=500', excerpt: 'Eğitimde gönüllülüğün hikayesini aktaran saha anlatımları.' },
  { id: 'p3', type: 'Kitap', title: 'Anadolu Çocukları', year: 2017, pages: 168, cover: 'https://images.pexels.com/photos/159711/books-bookstore-book-reading-159711.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=700&w=500', excerpt: "Anadolu'dan bursiyer hikâyeleri." },
];

export const MAGAZINES = [
  { id: 'm1', title: 'YEKÜV Dergi', issue: 'Sayı 12 — Bahar 2026', cover: 'https://images.pexels.com/photos/1765033/pexels-photo-1765033.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=700&w=500', excerpt: 'Bu sayıda: Mezunlar Buluşması özel dosyası, AI atölyeleri röportajı.' },
  { id: 'm2', title: 'YEKÜV Dergi', issue: 'Sayı 11 — Kış 2025', cover: 'https://images.pexels.com/photos/3944405/pexels-photo-3944405.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=700&w=500', excerpt: 'Bu sayıda: 840 yeni bursiyer, kitap kampanyası raporu.' },
  { id: 'm3', title: 'YEKÜV Dergi', issue: 'Sayı 10 — Sonbahar 2025', cover: 'https://images.pexels.com/photos/2128249/pexels-photo-2128249.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=700&w=500', excerpt: "Bu sayıda: Anadolu'da öğretmen yolculukları dosyası." },
];

export const SCHOOL_GALLERY = [
  'https://images.pexels.com/photos/5212329/pexels-photo-5212329.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940',
  'https://images.pexels.com/photos/8471864/pexels-photo-8471864.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940',
  'https://images.pexels.com/photos/4143800/pexels-photo-4143800.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940',
  'https://images.pexels.com/photos/5212703/pexels-photo-5212703.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940',
];

export const EDUCATION_UNITS = [
  {
    id: 'mecidiyekoy',
    slug: 'vakif-merkezi-mecidiyekoy',
    name: 'Vakıf Merkezi',
    district: 'Mecidiyeköy',
    tag: 'Genel Merkez',
    image: '/units/mecidiyekoy.jpg',
    address: 'Ortaklar Cad. Bahçeler Sokak No:2 Daire: 9, Mecidiyeköy / İSTANBUL',
    phone: '444 28 39',
    email: 'yekuv@yekuv.org',
    summary: 'Vakfımızın tüm operasyonlarının yürütüldüğü genel merkez. Bağışçı ilişkileri, burs koordinasyonu ve kurumsal iletişim faaliyetlerinin kalbi.',
    description: '1992\'den bu yana vakfımızın kalbi, tüm ulusal faaliyetlerimizin planlanıp koordine edildiği merkezdir. Yönetim kurulu toplantılarımız, bağışçı buluşmalarımız ve idari işlerimiz burada yürütülür. Açık kapı politikamız çerçevesinde, bağışçı ve gönüllülerimizi hafta içi her gün ağırlıyoruz.',
    features: ['Yönetim Ofisleri', 'Bağışçı İlişkileri Birimi', 'Toplantı Salonu', 'Arşiv'],
    since: 1992,
  },
  {
    id: 'kiz-yurdu',
    slug: 'nilufer-gokay-kiz-ogrenci-yurdu',
    name: 'Nilüfer Gökay Kız Öğrenci Yurdu',
    district: 'Kadıköy',
    tag: 'Öğrenci Yurdu',
    image: '/units/kiz-yurdu-kadikoy.png',
    address: 'Kadıköy / İSTANBUL',
    phone: '444 28 39',
    email: 'kizyurdu@yekuv.org',
    summary: 'Kurucu başkanımız Prof. Dr. Nilüfer Gökay\'ın adını taşıyan, üniversite öğrencisi kızlarımıza ev sahipliği yapan yurdumuz.',
    description: 'İstanbul\'da üniversite okuyan kız öğrencilerimizin güvenli, destekleyici ve aidiyet duygusu yaratan bir ortamda eğitim hayatlarını sürdürebilmeleri için tasarlanmış yurt binamız. 96 öğrenci kapasiteli; çalışma salonu, kütüphanesi, yemekhanesi ve sosyal alanlarıyla tam donanımlıdır.',
    features: ['96 öğrenci kapasitesi', 'Çalışma salonu & kütüphane', 'Yemekhane', 'Mentorluk programı'],
    since: 1998,
  },
  {
    id: 'cetin-saman',
    slug: 'cetin-saman-egitimi-destek-birimi',
    name: 'Çetin Şaman Eğitimi Destek Birimi',
    district: 'Kadıköy',
    tag: 'Eğitim Merkezi',
    image: '/units/cetin-saman-kadikoy.png',
    address: 'Kadıköy / İSTANBUL',
    phone: '444 28 39',
    email: 'cetinsaman@yekuv.org',
    summary: 'Anadolu yakasındaki bursiyerlerimize yönelik atölyeler, seminerler ve ders destek programlarının düzenlendiği merkez.',
    description: 'Çetin Şaman Eğitim Destek Birimi, Anadolu yakasında yaşayan bursiyerlerimize sosyal, akademik ve kültürel destek sağlayan eğitim merkezimizdir. Burada yaz okulu, sınav hazırlık, yazılım, yabancı dil ve kültür-sanat atölyeleri düzenlenir.',
    features: ['Ders destek programları', 'Dil & kodlama atölyeleri', 'Kültür-sanat etkinlikleri', 'Mentorluk'],
    since: 2008,
  },
  {
    id: 'seniye-turac',
    slug: 'seniye-turac-egitimi-destek-birimi',
    name: 'Seniye Turaç Eğitimi Destek Birimleri',
    district: 'Şişli',
    tag: 'Eğitim Merkezi',
    image: '/units/seniye-turac-sisli.png',
    address: 'Şişli / İSTANBUL',
    phone: '444 28 39',
    email: 'seniyeturac@yekuv.org',
    summary: 'Şişli bölgesindeki öğrenci ve ailelere yönelik eğitim destek ve rehberlik hizmetlerini yürüten birimimiz.',
    description: 'Seniye Turaç Eğitimi Destek Birimi, Şişli ve çevresindeki öğrencilerimize ve ailelerine eğitim danışmanlığı, rehberlik ve sosyal destek programları sunan merkezimizdir. Özellikle orta öğretim ve lise kademesindeki bursiyerlerimize hizmet verir.',
    features: ['Eğitim danışmanlığı', 'Veli görüşmeleri', 'Akademik takip', 'Psikolojik destek'],
    since: 2012,
  },
  {
    id: 'nilufer-gokay-beyoglu',
    slug: 'nilufer-gokay-egitimi-destek-birimi-beyoglu',
    name: 'Nilüfer Gökay Eğitimi Destek Birimi',
    district: 'Beyoğlu',
    tag: 'Eğitim Merkezi',
    image: '/units/nilufer-gokay-beyoglu.png',
    address: 'Beyoğlu / İSTANBUL',
    phone: '444 28 39',
    email: 'nilufergokay.beyoglu@yekuv.org',
    summary: 'Beyoğlu\'nda kurucu başkanımızın adını taşıyan, öğrencilerimize yönelik eğitim faaliyetlerinin merkezi.',
    description: 'Beyoğlu merkezimiz, kurucu başkanımız Prof. Dr. Nilüfer Gökay\'ın değerli mirasını yaşatan bir eğitim alanıdır. Bölgedeki öğrencilere kitap, ders desteği, atölye ve kariyer danışmanlığı hizmetleri sunar.',
    features: ['Okuma & kütüphane', 'Atölyeler', 'Kariyer danışmanlığı', 'Sosyal etkinlikler'],
    since: 2015,
  },
  {
    id: 'arif-hikmet',
    slug: 'arif-hikmet-evgin-egitimi-destek-birimi',
    name: 'Arif Hikmet Evgin Eğitimi Destek Birimi',
    district: 'Şenesenevler',
    tag: 'Eğitim Merkezi',
    image: '/units/arif-hikmet-senesenevler.png',
    address: 'Şenesenevler / İSTANBUL',
    phone: '444 28 39',
    email: 'arifhikmetevgin@yekuv.org',
    summary: 'Şenesenevler\'de yer alan, bölge çocuk ve gençlerine eğitim desteği sunan merkezimiz.',
    description: 'Arif Hikmet Evgin Eğitimi Destek Birimi, Şenesenevler ve çevre mahallelerdeki öğrencilere akademik ve sosyal destek vermek amacıyla hizmet verir. Velilere yönelik bilgilendirme seminerleri ve çocuklara yaratıcı atölye programları düzenlenir.',
    features: ['Yaratıcı atölyeler', 'Veli seminerleri', 'Ders destek', 'Okuma saatleri'],
    since: 2016,
  },
  {
    id: 'nuruosmaniye',
    slug: 'nilufer-gokay-egitimi-destek-birimi-nuruosmaniye',
    name: 'Nilüfer Gökay Eğitimi Destek Birimi',
    district: 'Nuruosmaniye',
    tag: 'Eğitim Merkezi',
    image: '/units/nilufer-gokay-nuruosmaniye.png',
    address: 'Nuruosmaniye / İSTANBUL',
    phone: '444 28 39',
    email: 'nilufergokay.nuruosmaniye@yekuv.org',
    summary: 'Tarihi yarımadanın kalbinde, tarihi doku içinde kültürel eğitim programlarının yürütüldüğü birimimiz.',
    description: 'Nuruosmaniye birimimiz, tarihi yarımadanın kalbinde yer alan özel konumuyla kültürel miras, sanat tarihi ve edebiyat atölyeleri için özel programlar düzenler. Çevre ilçelerdeki öğrencilerimize de kapısını açar.',
    features: ['Kültürel miras gezileri', 'Edebiyat atölyeleri', 'Sanat tarihi dersleri', 'Tarihi şehir turları'],
    since: 2018,
  },
];

export const SPONSORS = [
  { name: 'Koç Holding', category: 'Ana Destekçi' },
  { name: 'Sabancı Vakfı', category: 'Ana Destekçi' },
  { name: 'Türk Eğitim Vakfı', category: 'Stratejik Ortak' },
  { name: 'ACEV', category: 'Stratejik Ortak' },
  { name: 'TEGV', category: 'Stratejik Ortak' },
  { name: 'TÜSİAD', category: 'Kurumsal Destek' },
  { name: 'Garanti BBVA', category: 'Kurumsal Destek' },
  { name: 'İş Bankası', category: 'Kurumsal Destek' },
  { name: 'Yapı Kredi', category: 'Kurumsal Destek' },
  { name: 'Vakıfbank', category: 'Kurumsal Destek' },
  { name: 'Boğaziçi Ü.', category: 'Akademik Ortak' },
  { name: 'İTÜ', category: 'Akademik Ortak' },
  { name: 'ODTÜ', category: 'Akademik Ortak' },
  { name: 'Anadolu Ajansı', category: 'Medya Ortağı' },
  { name: 'TRT', category: 'Medya Ortağı' },
  { name: 'Hürriyet', category: 'Medya Ortağı' },
];

// Projects extended
export const PROJECT_STATUS = {
  ONGOING: 'devam',
  COMPLETED: 'tamamlanan',
  EVENT: 'etkinlik',
};

export const PROJECTS_EXTRA = [
  { id: 'pr1', slug: 'anadolu-kutuphane-seferberligi', status: 'devam', category: 'Kampanya', title: "Anadolu Kütüphane Seferberliği", excerpt: '21 ilde 64 köy okuluna kütüphane kurma hedefimize ulaşıyoruz.', image: 'https://images.pexels.com/photos/2764674/pexels-photo-2764674.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940', date: 'Ocak 2026 — Sürüyor', progress: 72 },
  { id: 'pr2', slug: 'dijital-beceri-atolyeleri', status: 'devam', category: 'Atölye', title: 'Dijital Beceri Atölyeleri', excerpt: 'Yapay zekâ, kodlama ve dijital okuryazarlık atölyeleri.', image: 'https://images.unsplash.com/photo-1509062522246-3755977927d7?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Nzh8MHwxfHNlYXJjaHwyfHxjbGFzc3Jvb218ZW58MHx8fHwxNzc2NzAwODA4fDA&ixlib=rb-4.1.0&q=85', date: 'Eylül 2025 — Sürüyor', progress: 48 },
  { id: 'pr3', slug: 'umut-kizlar', status: 'devam', category: 'Kampanya', title: 'Umut Kızlar', excerpt: 'Kız çocuklarının eğitim hakkı için özel destek programı.', image: 'https://images.pexels.com/photos/1462630/pexels-photo-1462630.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940', date: '2024 — Sürüyor', progress: 61 },
  { id: 'pr4', slug: 'mezunlar-bulusmasi-2026', status: 'tamamlanan', category: 'Buluşma', title: 'Mezunlar Buluşması 2026', excerpt: 'Yıllar sonra mezun bursiyerlerimizi buluşturduk.', image: 'https://images.pexels.com/photos/31895928/pexels-photo-31895928.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940', date: 'Şubat 2026' },
  { id: 'pr5', slug: '840-yeni-bursiyer', status: 'tamamlanan', category: 'Tören', title: '840 Yeni Bursiyer Töreni', excerpt: '2025-2026 eğitim yılı burs töreni tamamlandı.', image: 'https://images.pexels.com/photos/35610365/pexels-photo-35610365.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940', date: 'Ekim 2025' },
  { id: 'pr6', slug: 'anadoluya-ogretmen-yolculuklari', status: 'tamamlanan', category: 'Proje', title: "Anadolu'ya Öğretmen Yolculukları", excerpt: "Anadolu'nun dört bir yanında saha ziyaretleri.", image: 'https://images.unsplash.com/photo-1599689868384-59cb2b01bb21?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MTJ8MHwxfHNlYXJjaHwxfHxjaGlsZHJlbiUyMHJlYWRpbmd8ZW58MHx8fHwxNzc2NzAwODAyfDA&ixlib=rb-4.1.0&q=85', date: 'Kasım 2025' },
  { id: 'pr7', slug: 'kultur-sanat-atolyesi', status: 'etkinlik', category: 'Atölye', title: 'Kültür & Sanat Atölyesi', excerpt: 'Müzik, resim ve edebiyat atölyelerimizle buluşuyoruz.', image: 'https://images.pexels.com/photos/256514/pexels-photo-256514.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940', date: 'Her Cumartesi' },
  { id: 'pr8', slug: 'genclik-calistayi', status: 'etkinlik', category: 'Çalıştay', title: 'Gençlik Çalıştayı', excerpt: 'Gençlerde katılımcılığın güçlendirilmesi çalıştayı.', image: 'https://images.pexels.com/photos/18449721/pexels-photo-18449721.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940', date: 'Her yıl Nisan' },
  { id: 'pr9', slug: 'yil-sonu-gala', status: 'etkinlik', category: 'Gala', title: 'Yıl Sonu Dayanışma Galası', excerpt: 'Bağışçılar ve gönüllülerle yıllık buluşmamız.', image: 'https://images.pexels.com/photos/2774556/pexels-photo-2774556.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940', date: 'Aralık' },
];

export const STATS = [
  { value: 33, suffix: '+', label: 'Yıllık deneyim', sub: '1992\'den beri' },
  { value: 12500, suffix: '+', label: 'Bursiyer öğrenci', sub: 'Üniversite & lise' },
  { value: 340, suffix: '+', label: 'Aktif proje', sub: 'Eğitim & kültür' },
  { value: 81, suffix: '', label: 'İl', sub: 'Türkiye geneli' },
];

export const PROGRAMS = [
  {
    id: 'p1',
    title: 'Üniversite Bursu',
    kicker: 'Karşılıksız Destek',
    description:
      'İstanbul\'daki devlet üniversitelerini kazanmış, maddi desteğe ihtiyaç duyan başarılı öğrencilerimize karşılıksız eğitim bursu sağlıyoruz.',
    image: 'https://images.pexels.com/photos/33837414/pexels-photo-33837414.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940',
    link: '/burslar',
  },
  {
    id: 'p2',
    title: 'Lise & Ortaokul Destek',
    kicker: 'Fırsat Eşitliği',
    description:
      'Devlet okullarında örgün eğitim gören ilk/orta öğretim ve lise öğrencilerine eğitim hayatlarını sürdürebilmeleri için destek oluyoruz.',
    image: 'https://images.pexels.com/photos/31367492/pexels-photo-31367492.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940',
    link: '/burslar',
  },
  {
    id: 'p3',
    title: 'Kültür & Sanat',
    kicker: 'Sosyal Gelişim',
    description:
      'Bursiyerlerimizin ve gençlerin sosyal, eğitsel ve kültürel gelişimleri için atölyeler, buluşmalar ve geziler düzenliyoruz.',
    image: 'https://images.unsplash.com/photo-1577896851231-70ef18881754?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Nzh8MHwxfHNlYXJjaHw0fHxjbGFzc3Jvb218ZW58MHx8fHwxNzc2NzAwODA4fDA&ixlib=rb-4.1.0&q=85',
    link: '/projeler',
  },
  {
    id: 'p4',
    title: 'Gönüllülük Programı',
    kicker: 'Birlikte Güçlüyüz',
    description:
      'Türkiye genelindeki eğitim ve kültür faaliyetlerimizde bireysel ve kurumsal gönüllülerimizle büyük projelere imza atıyoruz.',
    image: 'https://images.pexels.com/photos/7692546/pexels-photo-7692546.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940',
    link: '/gonullu',
  },
];

export const STORIES = [
  {
    id: 's1',
    name: 'Elif Y.',
    role: 'Tıp Fakültesi, 4. sınıf',
    city: 'İstanbul',
    quote:
      'YEKÜV bursu sayesinde ailemin omuzlarındaki yükü alabildim. Şimdi ben de bir gün başka çocuklara aynı desteği vermeye hazırlanıyorum.',
    image: 'https://images.pexels.com/photos/28927920/pexels-photo-28927920.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940',
  },
  {
    id: 's2',
    name: 'Mert K.',
    role: 'Endüstri Mühendisliği',
    city: 'Ankara',
    quote:
      'Öğrenci buluşmaları bana yalnız olmadığımı gösterdi. Farklı şehirlerden arkadaşlarımla bir ağ kurduk, birlikte büyüyoruz.',
    image: 'https://images.pexels.com/photos/12949251/pexels-photo-12949251.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940',
  },
  {
    id: 's3',
    name: 'Zeynep A.',
    role: 'Psikoloji Mezunu',
    city: 'İzmir',
    quote:
      'Bursiyerliğim bittikten sonra gönüllü olarak döndüm. YEKÜV sadece bir vakıf değil, bir aile.',
    image: 'https://images.pexels.com/photos/32541876/pexels-photo-32541876.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940',
  },
];

export const NEWS = [
  {
    id: 'n1',
    slug: 'genclerde-katilimciligin-guclendirilmesi-calistayi',
    category: 'Çalıştay',
    title: 'Gençlerden Öğrenecek Çok Şey Var',
    excerpt:
      'Gençlerde katılımcılığın güçlendirilmesi çalıştayında farklı illerden gelen gençlerimizle bir araya geldik.',
    date: '10 Nisan 2026',
    image: 'https://images.pexels.com/photos/18449721/pexels-photo-18449721.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940',
    content:
      'YEKÜV olarak, Türkiye\'nin farklı illerinden gelen 120 genç ile katılımcılığın güçlendirilmesi çalıştayını gerçekleştirdik. İki gün süren programda; karar alma süreçleri, sivil toplum, topluluk organizasyonu ve dijital aktivizm başlıkları konuşuldu. Atölyelerde üretilen çıktılar, vakfımızın 2026 yol haritasına doğrudan yansıyacak.',
  },
  {
    id: 'n2',
    slug: 'mezunlar-bulusmasi',
    category: 'Buluşma',
    title: 'Mezunlar Buluşması',
    excerpt:
      'YEKÜV ailesinin mezunları yıllar sonra İstanbul\'da bir araya geldi. Kariyerlerini, hayallerini ve yeni projelerini paylaştılar.',
    date: '7 Şubat 2026',
    image: 'https://images.pexels.com/photos/31895928/pexels-photo-31895928.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940',
    content:
      '1992\'den bu yana binlerce bursiyere ev sahipliği yapan YEKÜV\'de yıllar sonra bir mezunlar buluşması düzenledik. Doktorlar, öğretmenler, mühendisler, sanatçılar — birbirinden farklı mesleklerdeki mezunlarımız hikâyelerini paylaştı.',
  },
  {
    id: 'n3',
    slug: 'kitap-bagis-kampanyasi',
    category: 'Kampanya',
    title: 'Kitap Bağış Kampanyası Başladı',
    excerpt:
      'Anadolu\'nun 21 ilindeki köy okullarına kütüphane kurmak için kitap bağış kampanyamız başladı.',
    date: '15 Ocak 2026',
    image: 'https://images.pexels.com/photos/5608541/pexels-photo-5608541.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940',
    content:
      'Her çocuğun kitaba ulaşma hakkı vardır. 21 ilde 64 köy okuluna kütüphane kurmayı hedeflediğimiz kampanyamıza sizi de bekliyoruz.',
  },
  {
    id: 'n4',
    slug: 'dijital-egitim-atolyesi',
    category: 'Atölye',
    title: 'Dijital Eğitim Atölyesi',
    excerpt:
      'Bursiyer öğrencilerimize yönelik dijital okuryazarlık ve yapay zeka atölyelerimiz başladı.',
    date: '20 Aralık 2025',
    image: 'https://images.unsplash.com/photo-1509062522246-3755977927d7?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Nzh8MHwxfHNlYXJjaHwyfHxjbGFzc3Jvb218ZW58MHx8fHwxNzc2NzAwODA4fDA&ixlib=rb-4.1.0&q=85',
    content:
      'Yapay zekâ çağında öğrencilerimizin bu teknolojilerden güçlenerek çıkması için ücretsiz atölyeler düzenliyoruz.',
  },
  {
    id: 'n5',
    slug: 'anadoluya-ogretmen-yolculuklari',
    category: 'Proje',
    title: "Anadolu'ya Öğretmen Yolculukları",
    excerpt:
      'Köy okullarına gönüllü öğretmenlerimizle kısa süreli saha ziyaretleri başlıyor.',
    date: '2 Kasım 2025',
    image: 'https://images.unsplash.com/photo-1599689868384-59cb2b01bb21?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MTJ8MHwxfHNlYXJjaHwxfHxjaGlsZHJlbiUyMHJlYWRpbmd8ZW58MHx8fHwxNzc2NzAwODAyfDA&ixlib=rb-4.1.0&q=85',
    content:
      'Anadolu\'nun dört bir yanındaki köy okullarına gönüllü öğretmenlerimizle bilim, sanat ve kodlama atölyeleri götürüyoruz.',
  },
  {
    id: 'n6',
    slug: 'yil-sonu-burs-toreni',
    category: 'Tören',
    title: 'Yıl Sonu Burs Töreni',
    excerpt:
      '2025-2026 eğitim yılı burs töreninde 840 yeni öğrencimize merhaba dedik.',
    date: '12 Ekim 2025',
    image: 'https://images.pexels.com/photos/35610365/pexels-photo-35610365.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940',
    content:
      'Bu yıl 840 yeni bursiyerimize merhaba dedik. Ailelerinin de katıldığı törende sahneye davet edilen öğrencilerimiz büyük coşku yaşattı.',
  },
];

export const BOARD = [
  { name: 'Prof. Dr. Ayşe Demir', role: 'Yönetim Kurulu Başkanı', avatar: '' },
  { name: 'Mehmet Karaca', role: 'Başkan Yardımcısı', avatar: '' },
  { name: 'Dr. Selim Öztürk', role: 'Genel Sekreter', avatar: '' },
  { name: 'Nihan Aydın', role: 'Sayman', avatar: '' },
  { name: 'Prof. Dr. Kemal Yılmaz', role: 'Yönetim Kurulu Üyesi', avatar: '' },
  { name: 'Leyla Şahin', role: 'Yönetim Kurulu Üyesi', avatar: '' },
];

export const TIMELINE = [
  { year: '1992', title: 'Vakfımız Kuruldu', text: 'YEKÜV, İstanbul\'da eğitim ve kültür alanında faaliyet göstermek üzere kuruldu.' },
  { year: '2001', title: 'İlk 1.000 Bursiyer', text: 'Kuruluşundan dokuz yıl sonra 1.000 öğrenciye karşılıksız burs sağladık.' },
  { year: '2010', title: 'Ulusal Ölçek', text: 'Türkiye\'nin 81 iline ulaşan programlar geliştirdik.' },
  { year: '2018', title: 'Dijital Dönüşüm', text: 'Online başvuru ve bağış altyapımız ile hizmetlerimizi herkese ulaştırdık.' },
  { year: '2025', title: '12.500+ Bursiyer', text: 'Toplam bursiyer sayımız 12.500\'ü aştı, 340 aktif projede ailemiz büyüyor.' },
];

export const BANK_INFO = [
  { bank: 'Türkiye İş Bankası', branch: 'Mecidiyeköy Şubesi', iban: 'TR00 0006 4000 0011 0123 4567 89', currency: 'TRY' },
  { bank: 'Garanti BBVA', branch: 'Şişli Şubesi', iban: 'TR00 0006 2000 0000 0456 7890 12', currency: 'TRY' },
  { bank: 'Yapı Kredi', branch: 'Levent Şubesi', iban: 'TR00 0006 7010 0000 0678 9012 34', currency: 'USD' },
];

export const DONATION_TIERS = [250, 500, 750, 1000, 1500, 2500];

export const FAQ = [
  { q: 'YEKÜV bursundan kimler yararlanabilir?', a: 'Devlet okullarında örgün eğitim gören, ekonomik yetersizlik yaşayan; İstanbul\'da devlet üniversitesini kazanmış, annesi/babası hayatta olmayan veya eğitimi devam eden kardeşleri olan öğrenciler önceliğimizdir.' },
  { q: 'Burs hangi dönemlerde verilir?', a: 'Burslar akademik yıl boyunca (Ekim — Haziran) 9 ay süresince düzenli olarak ödenir.' },
  { q: 'Özel üniversite öğrencileri başvurabilir mi?', a: 'Hayır. Özel ve vakıf üniversiteleri, ikinci öğretim, açık öğretim, uzaktan öğretim, yüksek lisans ve doktora öğrencileri burs yönetmeliğimiz kapsamı dışındadır.' },
  { q: 'Bağışım vergiden düşer mi?', a: 'Vakfımız kamu yararına çalışan statüsündedir; yaptığınız bağışlar ilgili mevzuat çerçevesinde vergi avantajı sağlar.' },
  { q: 'Gönüllü olarak nasıl destek verebilirim?', a: 'Gönüllülük Formu veya Kurumsal Gönüllülük Formu\'nu doldurarak bireysel veya kurumsal olarak destek verebilirsiniz.' },
];

export const HERO_IMAGES = [
  'https://images.pexels.com/photos/31367492/pexels-photo-31367492.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=1200&w=1600',
  'https://images.pexels.com/photos/28927920/pexels-photo-28927920.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=1200&w=1600',
  'https://images.pexels.com/photos/33837414/pexels-photo-33837414.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=1200&w=1600',
];

export const PARTNERS = [
  'İTÜ', 'Boğaziçi', 'ODTÜ', 'Koç Vakfı', 'Sabancı Vakfı', 'TÜSİAD', 'AÇEV', 'TEGV', 'Türk Eğitim Vakfı',
];

export const ADMIN = {
  user: 'admin',
  pass: 'yekuv2026',
};
